module.exports = __webpack_public_path__ + "img/picture_ksdgmn.0485ce97.png";